import { devWarn } from "@/lib/log";
import { useEffect, useState } from "react";
import { Outlet, useNavigate, Link, NavLink } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import { Package, ClockCounterClockwise, SignOut } from "@phosphor-icons/react";
import WhatsappButton from "@/components/WhatsappButton";

export default function CustomerLayout({ user, setUser }) {
  const navigate = useNavigate();
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { devWarn("Logout call failed — clearing local session anyway", e); }
    setUser(null);
    navigate("/customer/login");
    toast.success("Signed out");
  };

  return (
    <div className="min-h-screen bg-zinc-50">
      <header className="border-b border-zinc-200 bg-white">
        <div className="max-w-5xl mx-auto px-6 h-14 flex items-center justify-between">
          <Link to="/customer" className="flex items-center gap-2" data-testid="customer-home-link">
            <Package size={18} weight="bold" />
            <span className="font-black tracking-tight">Ronnex Customer Portal</span>
          </Link>
          <nav className="flex items-center gap-1 text-sm">
            <NavItem to="/customer">My Orders</NavItem>
            <NavItem to="/customer/new">Place Order</NavItem>
            <WhatsappButton label="Help" testId="customer-whatsapp-button" />
            <button
              onClick={logout}
              className="ml-2 flex items-center gap-1 px-3 py-1.5 text-xs uppercase tracking-widest text-zinc-500 hover:text-zinc-900 transition-colors"
              data-testid="customer-logout"
            >
              <SignOut size={14} weight="bold" />
              Sign out
            </button>
          </nav>
        </div>
      </header>
      <main className="max-w-5xl mx-auto px-6 py-8">
        <Outlet context={{ user }} />
      </main>
    </div>
  );
}

function NavItem({ to, children }) {
  return (
    <NavLink
      to={to}
      end
      className={({ isActive }) =>
        `px-3 py-1.5 text-xs uppercase tracking-widest transition-colors ${
          isActive ? "bg-zinc-900 text-white" : "text-zinc-600 hover:text-zinc-900"
        }`
      }
    >
      {children}
    </NavLink>
  );
}
